import { render, staticRenderFns } from "./epmallitem.vue?vue&type=template&id=8d02321c"
import script from "./epmallitem.vue?vue&type=script&lang=js"
export * from "./epmallitem.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./epmallitem.vue?vue&type=style&index=1&id=8d02321c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports